import { Controller } from "@hotwired/stimulus"
import { badgeClasses } from '@/utils/badge_classes'

// Handles the tax organizer details modal
// Populates organizer data and coordinates with question filter controller
export default class extends Controller {
  static targets = ["customerName", "year", "statusBadge", "titleIcon", "frameContent"]
  static outlets = ["admin--tax-organizer--question-filter"]

  static values = {
    accountId: String,
    organizerId: String
  }

  connect() {
    // Listen for Bootstrap modal events
    this.element.addEventListener('show.bs.modal', this.handleModalShow.bind(this))
    this.element.addEventListener('hidden.bs.modal', this.handleModalHidden.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('show.bs.modal', this.handleModalShow.bind(this))
    this.element.removeEventListener('hidden.bs.modal', this.handleModalHidden.bind(this))
  }

  frameContentTargetConnected(target) {
    // When turbo frame content loads, reinforce the icon color
    // (This is redundant if handleModalShow already set it, but ensures consistency)
    const statusColor = target.dataset.statusColor

    if (statusColor && this.hasTitleIconTarget) {
      this.titleIconTarget.classList.remove('text-primary', 'text-secondary', 'text-warning', 'text-success', 'text-muted')
      this.titleIconTarget.classList.add(statusColor)
    }
  }

  handleModalShow(event) {
    // Get the button/link that triggered the modal
    const trigger = event.relatedTarget

    if (trigger) {
      const accountName = trigger.getAttribute('data-account-name')
      const accountId = trigger.getAttribute('data-account-id')
      const organizerId = trigger.getAttribute('data-organizer-id')
      const year = trigger.getAttribute('data-year')
      const status = trigger.getAttribute('data-status')
      const statusColor = trigger.getAttribute('data-status-color')

      // Immediately set the icon color if we have it
      if (statusColor && this.hasTitleIconTarget) {
        this.titleIconTarget.classList.remove('text-primary', 'text-secondary', 'text-warning', 'text-success', 'text-muted')
        this.titleIconTarget.classList.add(statusColor)
      }

      // Populate modal data
      if (this.hasCustomerNameTarget && accountName) {
        this.customerNameTarget.textContent = accountName
      }

      if (this.hasYearTarget && year) {
        this.yearTarget.textContent = year
      }

      // Store IDs for potential AJAX requests
      this.accountIdValue = accountId || ''
      this.organizerIdValue = organizerId || ''

      // Update status badge
      if (this.hasStatusBadgeTarget && status) {
        this.updateStatusBadge(status)
      }

      // TODO: Load actual tax organizer questions via Turbo Frame using organizerId
      // For now, mock data is displayed
    }
  }

  handleModalHidden() {
    // Reset question filter when modal closes
    if (this.hasAdminTaxOrganizerQuestionFilterOutlet) {
      this.adminTaxOrganizerQuestionFilterOutlet.reset()
    }
  }

  updateStatusBadge(status) {
    const statusConfig = {
      'sent': { text: 'Sent', variant: 'info' },
      'in_progress': { text: 'In Progress', variant: 'warning' },
      'completed': { text: 'Completed', variant: 'success' },
      'submitted': { text: 'Submitted', variant: 'primary' }
    }

    const config = statusConfig[status]
    if (config) {
      this.statusBadgeTarget.textContent = config.text
      this.statusBadgeTarget.className = badgeClasses({ variant: config.variant })
    }
  }
}
